import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },

  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1rem',
    marginBottom: '1.75rem',

    '& span': {
      padding: '0.3rem 0.4rem',
      borderRadius: '2rem',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      color: '#fff',
    },
  },

  headerText: {
    '& h1': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      padding: 0,

      '& span': {
        fontFamily: 'Sora',
        fontWeight: '400',
        fontSize: '34px',
        lineHeight: '42px',
        padding: '1rem 0',
        color: '#000000',
      },
    },

    '& div': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',

      '& h4': {
        padding: '0',
        margin: '0',
        fontWeigth: '700',
      },

      '& h5': {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0',
        padding: '0',
        margin: '0',
        fontFamily: 'Nunito',
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '22px',
      },
    },
  },

  statusActive: {
    background: '#2E7D32',
  },

  statusInactive: {
    background: '#D8000C',
  },
}))

export { useStyles }
